/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-15 10:38:33
 * @FilePath: /vise/packages/app-share/src/composable/use-get-common-method/get-growth-test-methods.ts
 */
import useProvideBrowserInfo from '@/composable/use-provide-browser-info';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import { IHashMap } from '@/types/data';
import { FetchShareStrategyResult } from '@/types/services/fetch-share-strategy';

export default function getGrowthTestMethods() {
  const { info } = useProvideBrowserInfo();
  const { info: urlInfo } = useProvideUrlInfo();

  const getGrowthTestDataVal = function (val: number|boolean|string|IHashMap) {
    const valType = typeof (val !== undefined ? val : true);
    const { debug } = urlInfo.query;
    // 如果url上参数debug有值，全部开关都开启，方便调试
    if (!debug) {
      return val;
    }
    if (valType === 'boolean') {
      return true;
    }
    if (valType === 'number') {
      return 1;
    }
  };

  const getGrowthTestDataFromRes = function (growthTestData: FetchShareStrategyResult) {
    const data: IHashMap  = { ...growthTestData };
    Object.keys(data).forEach((key) => {
      data[key] = getGrowthTestDataVal(data[key]);
    });
    const miniAppSwitchs = data.ext || {};
    if (info.client === 'wx') {
      Object.keys(miniAppSwitchs).forEach((key) => {
        miniAppSwitchs[key] = parseInt(miniAppSwitchs[key], 10);
      });
      data.miniAppSwitchs = miniAppSwitchs;
    }
    return data as FetchShareStrategyResult;
  };

  const getGrowthTestScene = function () {
    let { scene } = urlInfo.query;
    const map = {
      default: '0',
      qq: '1',
      wx: '2',
      infoflow: '3',
    };
    // 优先级最高
    if (scene === 'infoflow') {
      scene = map.infoflow;
    }
    if (!scene) {
      if (info.client === 'qq') {
        scene = map.qq;
      }
      if (info.client === 'wx') {
        scene = map.wx;
      }
    }
    return parseInt(scene || map.default, 10);
  };

  return {
    getGrowthTestDataVal, getGrowthTestScene, getGrowthTestDataFromRes,
  };
}
